var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_671_9768)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.5,
    width: 55,
    height: 55,
    rx: 11.5,
    stroke: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4997 30.249C43.1682 30.249 42.8502 30.3807 42.6158 30.6151C42.3814 30.8496 42.2497 31.1675 42.2497 31.499V36.7653C42.2487 37.6889 41.8813 38.5744 41.2282 39.2276C40.5751 39.8807 39.6896 40.248 38.7659 40.249H23.2334C22.3098 40.248 21.4243 39.8807 20.7712 39.2276C20.118 38.5744 19.7507 37.6889 19.7497 36.7653V31.499C19.7497 31.1675 19.618 30.8496 19.3836 30.6151C19.1492 30.3807 18.8312 30.249 18.4997 30.249C18.1682 30.249 17.8502 30.3807 17.6158 30.6151C17.3814 30.8496 17.2497 31.1675 17.2497 31.499V36.7653C17.2513 38.3518 17.8823 39.8728 19.0041 40.9946C20.1259 42.1164 21.647 42.7474 23.2334 42.749H38.7659C40.3524 42.7474 41.8735 42.1164 42.9953 40.9946C44.1171 39.8728 44.748 38.3518 44.7497 36.7653V31.499C44.7497 31.1675 44.618 30.8496 44.3836 30.6151C44.1492 30.3807 43.8312 30.249 43.4997 30.249Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3833 24.8825L29.7496 19.5163V35.2488C29.7496 35.5803 29.8813 35.8982 30.1157 36.1326C30.3501 36.3671 30.6681 36.4988 30.9996 36.4988C31.3311 36.4988 31.6491 36.3671 31.8835 36.1326C32.1179 35.8982 32.2496 35.5803 32.2496 35.2488V19.5163L37.6158 24.8825C37.8516 25.1102 38.1673 25.2362 38.4951 25.2333C38.8228 25.2305 39.1364 25.099 39.3681 24.8673C39.5999 24.6355 39.7313 24.322 39.7342 23.9943C39.737 23.6665 39.611 23.3508 39.3833 23.115L31.8833 15.615C31.6489 15.3807 31.331 15.249 30.9996 15.249C30.6681 15.249 30.3503 15.3807 30.1158 15.615L22.6158 23.115C22.3881 23.3508 22.2622 23.6665 22.265 23.9943C22.2678 24.322 22.3993 24.6355 22.6311 24.8673C22.8628 25.099 23.1763 25.2305 23.5041 25.2333C23.8318 25.2362 24.1476 25.1102 24.3833 24.8825Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_671_9768",
    x: 0.5,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_671_9768"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_671_9768",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.c1b8e2f29da6514089b13505f8cec485.svg";
export { ForwardRef as ReactComponent };